<template>
  <div class="WizardForm">
    <transition-group name="slide-fade">
      <div
        v-for="question in questions"
        :key="question.id"
        class="question-wrapper">
        <h3
          class="FormRow-labelRadio"
          v-text="question.questionTitle" />
        <div class="FormRow">
          <div class="FormRow-input Form-col2 Form-inputRadio">
            <div class="Form-inputRadioInner">
              <div
                v-for="(answer, key) in question.answers"
                :key="key">
                <input
                  :name="`question${question.id}`"
                  :id="`q${question.id}-answer-${key}`"
                  :value="answer.gameOverAnswer ? 'not-eligible' : (answer.answerValue ? answer.answerValue : answer.answer)"
                  v-model="formData[question.id]"
                  @input="dataLayerEvent(question)"
                  type="radio"
                />
                <label
                  class=""
                  :for="`q${question.id}-answer-${key}`"
                  v-html="answer.answer" />
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition-group>

    <div
      v-if="hasAnInvalidConfiguration"
      class="sorry">
      Désolé votre configuration n'est pas éligible à nos services
    </div>
    <template v-else>
      <div class="CartRecap-submit">
        <ProgressButton
          :order="false"
          :hiddenButton="false"
          :lastStep="true"
          @checkout="handleCheckout"
          :fromWizardForm="true"
        ></ProgressButton>
      </div>

      <div class="CartRecap-CGV">
        <p>
          En finalisant votre commande vous acceptez les
          <a :href="cartCgv" target="_blank">Conditions Générales d’Utilisation*</a>
        </p>
      </div>
    </template>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import ProgressButton from "@/components/ProgressButton/ProgressButton.vue";

import "@/components/Wizard/WizardForm/WizardForm.scss";

export default {
  name: "WizardForm",

  components: {
    ProgressButton,
  },

  data() {
    return {
      form: {
        prefix: "",
        cgv: false,
      },
      formData: {}
    };
  },

  props: {
    isLandingOrLead: {
      type: Boolean,
      default: false
    }
  },

  computed: {
    ...mapGetters({
      cartCgv: "getCurrentCartCGV",
      getWizardStrapiForm: "getWizardStrapiForm"
    }),
    
    hasAnInvalidConfiguration() {
      return Object.values(this.formData).find(i => i === 'not-eligible');
    },

    questions() {
      const form = this.getWizardStrapiForm;
      
      if (!Array.isArray(this.getWizardStrapiForm)) {
        return [];
      }
      if (Object.values(this.formData).find(i => i === 'not-eligible') === "not-eligible") return form.slice(0, this.formAnswers.length || 1);

      return form.slice(0, this.formAnswers.length + 1 || 1);
    },

    formAnswers() {
      const answers = Object.keys(this.formData).reduce((arr, key, index) => {
        let questionAnswer = {};
        questionAnswer[`q${index + 1}`] = this.getWizardStrapiForm[index].questionTitle;
        questionAnswer[`r${index + 1}`] = this.formData[key];
        questionAnswer[`field_${index + 1}`] = this.getWizardStrapiForm[index].mcpDatabaseField;
        arr.push(questionAnswer);
        return arr;
      }, []);
      return answers;
    }
  },

  updated() {
    this.wizardFillProgress();
  },

  methods: {
    
    wizardFillProgress() {
      let fieldNumber = this.getWizardStrapiForm.length;
      let remain = fieldNumber;
      const fields = this.formData;
      Object.keys(fields).forEach((key) => {
        remain--;
      });
      this.$store.dispatch('setWizardFillPercentLast', 100 - (remain * 100) / fieldNumber);
    },

    handleCheckout() {
      
      this.$store.dispatch('setWizardFormAnswers', Object.freeze(this.formAnswers));
      this.$emit('checkout');
    },

    getAnswerTextContent(target) {
      let containerNode       = target.parentNode;
      let answerTextContent   = containerNode.querySelector('figcaption') ? 
                                  containerNode.querySelector('figcaption').textContent :
                                  containerNode.querySelector('label p').textContent;
      
      return answerTextContent;
    },


    /* 
        Find a better way (look in Strapi)
    */
  /**
   * get Gtm strapi event name
   * @param {String} title - Question title
   */
    getGtmEventName(title) {
      let eventName       = '';
      const datasMapping  = {
        "occupant_status" : [
                              "Êtes-vous propriétaire ou locataire ?", 
                              "Etes-vous locataire ou propriétaire ?",
                              "Êtes-vous locataire ou propriétaire ?",
                            ],
        "home_type"       : [
                              "L'installation concerne une maison ou un appartement ?",
                              "Quel est le type de votre logement ?",
                              "Type de logement"
                            ],
        "heating_type"    : ["Quel est votre type de chauffage actuel ?"],
        "energy_label"    : ["Quelle est l'étiquette énergétique de votre logement ?"]
      }

      Object.keys(datasMapping).forEach(key => {
          if(datasMapping[key].includes(title)) eventName = key;
      })

      return eventName;
    },

  /**
   * Push in datalayer Object
   * @param {Object} title - Question title
   */
    dataLayerEvent(question) {
      if(!this.isLandingOrLead) return;

      const eventName = this.getGtmEventName(question.questionTitle);
      const eventText = this.getAnswerTextContent(event.target);

      let datasToPersist = {};
      datasToPersist[eventName] = eventText;

      if(window.McpGtm) McpGtm.pushCustomDataLayer(`devis_${eventName}`, {}, datasToPersist, 'product')
    }
  },
};
</script>
